import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ModalModule } from 'ngx-bootstrap/modal';

import { JobRoutes } from './job.routes';
import { ProgressComponent } from './component/progress/progress.component';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { CommonModule } from '@angular/common';
import { UiModule } from '../../shared/ui/ui.module';

@NgModule({
  declarations: [
    ProgressComponent
  ],
  entryComponents: [],
  imports: [
    RouterModule.forChild(JobRoutes),
    ModalModule.forRoot(),
    ProgressbarModule,
    CommonModule,
    UiModule
  ],
  providers: [],
  exports: [
    ProgressComponent
  ]
})
export class JobModule {

}
